import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Projectpendingjoiner } from '../model/projectpendingjoiner';

@Injectable({
  providedIn: 'root'
})
export class OrgprojectpendingjoinerlistService {

  constructor(private http:HttpClient) { }

  getPendingJoiners(projectId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Projectpendingjoiner[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+"/project/"+projectId+"/pendingjoiners",httpOptions)
  }

  acceptPendingJoiner(projectId:string,personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.patch(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+"/project/"+projectId+"/pendingjoiners/"+personId+"/accept","",httpOptions)

  }
  saveRole(joiner:Projectpendingjoiner){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+"/projectperson/"+joiner.projectId+"/person/"+joiner.personId,joiner,httpOptions)
  
  }
  
  declinePendingJoiner(projectId:string,personId:string){
    var decline_msg = {decline_msg: "Declined by user "+personId};
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+"/project/"+projectId+"/pendingjoiners/"+personId+"/decline",JSON.stringify(decline_msg),httpOptions)

  }
}
